export default "__VITE_ASSET__Dkhh$CRB__"